import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import { Button, Table, Modal, Dropdown } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import DashboardContext from 'Context';
import Loader from '../../layout/Loader';
import ModalDelete from '../ModalDelete';
import '../tabel.css';
import InputDate from 'components/inputs/InputDate';
import { toast } from 'react-toastify';
import NumberFormat from 'react-number-format';
import InputMask from 'react-input-mask';
import ConfirmModal from '../../ConfirmModal';
import moment from 'moment-jalaali';
import toaster from 'helper/toaster';
import {
  Alert,
  Col,
  Descriptions,
  Divider,
  Form,
  Row,
  Skeleton,
  Space,
  Tooltip,
} from 'antd';
import InputControl from 'components/inputs/InputControl';

export default function TableEditB2BWorker({
  isFromProfile,
  urldata,
  arryactions,
  isform,
  itemname,
  params,
  page,
  pageSiz,
}) {
  const {
    sideBardata,
    authentication,
    urldashboard,
    idview,
    // accessPage,
    handelloding,
    dataFromTabel,
    handelerrors,
    setorderLoader,
    orderLoader,
    searchLoading,
    setOffSearchLoding,
  } = useContext(DashboardContext);
  const { location } = useHistory();
  const [penaltyForm] = Form.useForm();
  const [record, setRecord] = useState({});
  const [dataFech, setDataFech] = useState([]);
  const [penaltyData, setPenaltyData] = useState({});
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [penaltyModal, setPenaltyModal] = useState(false);
  const [descriptionModal, setDescriptionModal] = useState(false);

  const [startpage, setStartpage] = useState(
    page ? page : JSON.parse(sessionStorage.getItem('startpage')) || 1
  );
  const [shouldShow, setShouldShow] = useState(false);
  const [pageSize] = useState(
    pageSiz ? pageSiz : JSON.parse(sessionStorage.getItem('pageSize')) || 10
  );
  const [serch, setSerch] = useState(
    JSON.parse(sessionStorage.getItem('serch')) || ''
  );
  const [itemData] = useState(null);
  const [dates, setDates] = useState([]);
  const [history, setHistory] = useState([]);
  const [, setCalculatedPrices] = useState({});
  const [penaltyBox, setPenaltyBox] = useState({});
  const [idForModal, setIdForModal] = useState(null);
  const [showMudule, setShowMudule] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [penaltyLoading, setPenaltyLoading] = useState(false);
  const [supportDescription, setSupportDescription] = useState('');
  const [submitDescriptionLoading, setSubmitDescriptionLoading] =
    useState(false);

  const handleClose = () => setShowMudule(false);
  const handleValue = (name, value) => {
    setDates({ ...dates, [name]: value });
  };

  const handleSubmit = async (item) => {
    let condition = item.realInputTime && item.realOutputTime;
    if (condition) {
      item.inputTime = item.realInputTime;
      item.outputTime = item.realOutputTime;

      updateprice(item);
      toast.info(
        'زمان تغییر یافت . لطفا برای ذخیره سازی زمان بر روی دکمه بروزرسانی کلیک کنید'
      );
    }
  };

  const DateStart = (date) => {
    return moment(date)?.format('jYYYY-jMM-jDD');
  };

  const handeldelete = () => {
    handleClose();
  };

  const [loadingFrom] = useState(false);
  var datafeching = async (startpage, pageSize, serch, item) => {
    let formdata = {};
    if (isform) {
      formdata = {
        page: parseInt(startpage),
        pageSize: parseInt(pageSize),
        isFromProfile: isFromProfile,
        search: serch,
        [itemname]: params
          ? params
          : JSON.parse(sessionStorage.getItem('customerid'))
          ? JSON.parse(sessionStorage.getItem('customerid'))
          : idview,
      };
    } else {
      formdata = {
        page: parseInt(startpage),
        pageSize: parseInt(pageSize),
        search: serch,
        isFromProfile: isFromProfile,
      };
    }

    try {
      const res = await Axios.post(
        `${urldashboard}${urldata ? urldata : location.pathname}/get`,
        JSON.stringify(formdata),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );

      const data = res.data;
      setDataFech(data.data);
      setOffSearchLoding();
      handelloding(false);
      setorderLoader(false);
    } catch (error) {
      handelerrors(error);
    }
  };

  const updateprice = async (item) => {
    try {
      const res = await Axios.post(
        `${urldashboard}/workerorderschedule/pricecalculation`,
        JSON.stringify({
          id: item.id,
          startWork: item.realInputDateTime,
          endWork: item.realOutputDateTime,
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json; charset=utf-8 ',
          },
        }
      );
      const data = res.data.data;
      setCalculatedPrices((prev) => ({ ...prev, [item.id]: data.newPrice }));
    } catch (error) {
      //console.log(error);
    }
  };

  const settimekarline = async (item) => {
    item.inputTime = item.realInputTime;
    item.outputTime = item.realOutputTime;
    setDataFech([...dataFech]);
    const ItemData = {
      id: item.id,
      startWork: `${
        dates.startWork ? dates.startWork : item.startWork?.slice(0, 10)
      }T${item.inputTime}`,
      endWork: `${
        dates?.endWork ? dates.endWork : item.endWork?.slice(0, 10)
      }T${item.outputTime}`,
    };

    try {
      setorderLoader(true);
      const respo = await Axios.post(
        `${urldashboard}/workerorderschedule/UpdatePriceCalculationB2B`,
        ItemData,
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json; charset=utf-8 ',
          },
        }
      );

      toast.info(respo?.data?.message);
      const data = await respo.data.data;
      setCalculatedPrices((prev) => ({ ...prev, [item.id]: data.newPrice }));
      setorderLoader(false);
    } catch (error) {
      toast.warning(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (!showMudule) {
      datafeching(startpage, pageSize, serch);
    }
  }, [startpage, pageSize, serch, dataFromTabel, searchLoading, showMudule]);

  const handleDescription = async (id) => {
    setIdForModal(id);
    try {
      let url = `/workerOrderSchedule/supportDescription/${id}`;
      const response = await Axios.get(urldashboard + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });
      const data = await response?.data?.data;
      setHistory(data);
      setIsReadOnly(true);
      setDescriptionModal(true);
    } catch (error) {
      handelerrors(error);
    }
  };

  const submitPenalty = async () => {
    if (!penaltyData?.workCancelPolicyId) {
      return toaster.error('لطفا عنوان لغو کار را وارد کنید.');
    }

    if (!penaltyData?.workActionReasonId) {
      return toaster.error('لطفا دلیل لغو کار را وارد کنید.');
    }

    setSubmitLoading(true);

    try {
      let url = '/workerOrderSchedule/deleteWithPenalty';

      const response = await Axios.post(
        urldashboard + url,
        {
          ...penaltyData,
          workerOrderScheduleId: idForModal,
        },
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      toaster.success(response?.data?.message);
      setSubmitLoading(false);
      setIdForModal(null);
      setPenaltyModal(false);
      setPenaltyData({});
      await datafeching(startpage, pageSize, serch);
    } catch (error) {
      handelerrors(error);
      setSubmitLoading(false);
    }
  };

  const submitDescription = async () => {
    setSubmitDescriptionLoading(true);

    try {
      let url = '/workerOrderSchedule/supportDescription';

      const response = await Axios.put(
        urldashboard + url,
        JSON.stringify({
          workerOrderSchedulerId: idForModal,
          supportDescription: supportDescription,
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      toaster.success(response?.data?.message);
      setSubmitDescriptionLoading(false);
      setIdForModal(null);
      setDescriptionModal(false);
      setSupportDescription('');
      await datafeching(startpage, pageSize, serch);
    } catch (error) {
      handelerrors(error);
      setSubmitDescriptionLoading(false);
    }
  };

  const getPenaltyAmount = async (id) => {
    setPenaltyLoading(true);

    try {
      let url = '/workerOrderSchedule/getDeleteWithPenaltyInformation';

      const response = await Axios.post(
        urldashboard + url,
        JSON.stringify({
          workerOrderScheduleId: idForModal,
          workCancelPolicyId: id,
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      setPenaltyBox(response?.data?.data);
      setPenaltyLoading(false);
      await datafeching(startpage, pageSize, serch);
    } catch (error) {
      handelerrors(error);
      setPenaltyLoading(false);
    }
  };

  const handleChange = (name, value) => {
    setPenaltyData({ ...penaltyData, [name]: value });
    if (name === 'workCancelPolicyId' && value) getPenaltyAmount(value);
  };

  return (
    <>
      {sideBardata?.length > 0 ? (
        <>
          {!orderLoader ? (
            dataFech?.length > 0 ? (
              <>
                <div className='table-responsive tabeldata'>
                  <Table hover bordered>
                    <thead>
                      <tr>
                        <th>ردیف</th>
                        <th>عملیات</th>
                        <th>نام نیرو و شماره موبایل</th>
                        <th>ساعت ورود</th>
                        <th>ساعت خروج</th>
                        <th>هزینه قابل پرداخت</th>
                        <th>توضیحات ثبت کننده ورود و خروج (PRM)</th>
                        <th>توضیحات کارشناس</th>
                        <th>وضعیت کار</th>
                        <th>اطلاعات لغو کار / سفارش</th>
                        <th>محاسبه</th>
                        {/* <td>تایید ساعت کارفرما</td>
                        <td>حذف</td>
                        <td>حذف با جریمه</td> */}
                      </tr>
                    </thead>
                    <tbody>
                      {dataFech.map((item, index) => {
                        return (
                          <>
                            <tr
                              style={{
                                backgroundColor:
                                  item?.type === 3
                                    ? '#c0ff02'
                                    : item?.type === 6 || item?.type === 7
                                    ? '#d7a49a80'
                                    : index % 2 !== 0
                                    ? '#e2e2e2'
                                    : 'inherit',
                              }}
                            >
                              <td>{++index}</td>
                              <td>
                                <Tooltip
                                  title={
                                    item?.type === 6 || item?.type === 7
                                      ? 'بدلیل اینکه کار / سفارش برای نیرو لغو شده است، انجام هرگونه عملیات ممکن نیست.'
                                      : ''
                                  }
                                >
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      style={{
                                        backgroundColor: '#464dee',
                                        color: '#ffffff',
                                      }}
                                      disabled={
                                        item?.type === 6 || item?.type === 7
                                      }
                                    ></Dropdown.Toggle>

                                    <Dropdown.Menu
                                      id={item?.id}
                                      align={'right'}
                                    >
                                      {/* {accessPage?.includes('Delete') && ( */}
                                      <Dropdown.Item
                                        className={'d-inline-flex primary-item'}
                                        onClick={async () => {
                                          await settimekarline(item);
                                          await datafeching(
                                            startpage,
                                            pageSize,
                                            serch,
                                            item
                                          );
                                        }}
                                      >
                                        محاسبه
                                      </Dropdown.Item>
                                      <Dropdown.Item
                                        className={'d-inline-flex danger-item'}
                                        onClick={() => {
                                          setShowMudule(true);
                                          setIdForModal(item.id);
                                        }}
                                      >
                                        حذف
                                      </Dropdown.Item>
                                      <Dropdown.Item
                                        className={'d-inline-flex danger-item'}
                                        onClick={() => {
                                          setIdForModal(item.id);
                                          setPenaltyModal(true);
                                        }}
                                      >
                                        لغو کار
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </Tooltip>
                              </td>
                              <td>
                                {item.workerFullName} {item.workerPhoneNo}
                              </td>
                              <td>
                                <tr>
                                  <td>
                                    <span>تاریخ ورود قرارداد: </span>
                                  </td>
                                  <td>
                                    <span>{DateStart(item?.startWork)}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span>ساعت ورود قرارداد: </span>
                                  </td>
                                  <td>
                                    <InputMask
                                      mask='99:99'
                                      maskChar={'0'}
                                      dir='ltr'
                                      value={item.inputTime}
                                      onChange={(e) => {
                                        item.inputTime = e.target.value;
                                        setDataFech([...dataFech]);
                                      }}
                                      disabled
                                    />
                                  </td>
                                </tr>

                                <tr>
                                  <td>تاریخ شروع کار</td>
                                  <td>
                                    <InputDate
                                      label=''
                                      name='startWork'
                                      handelValue={handleValue}
                                      defaultValue={item?.startWork?.slice(
                                        0,
                                        10
                                      )}
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span>ساعت ورود کارفرما: </span>
                                  </td>
                                  <td>
                                    <InputMask
                                      mask='99:99'
                                      placeholder='--:--'
                                      maskChar={'0'}
                                      dir='ltr'
                                      value={
                                        item.realInputTime !== null
                                          ? item.realInputTime
                                          : null
                                      }
                                      onChange={(e) => {
                                        item.realInputTime = e.target.value;
                                        setDataFech([...dataFech]);
                                      }}
                                    />
                                  </td>
                                </tr>
                              </td>

                              <td>
                                <tr>
                                  <td>
                                    <span>تاریخ خروج قرارداد: </span>
                                  </td>
                                  <td>
                                    <span>{DateStart(item?.endWork)}</span>
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <span>ساعت خروج قرارداد: </span>
                                  </td>
                                  <td>
                                    <InputMask
                                      mask='99:99'
                                      placeholder='--:--'
                                      maskChar={'0'}
                                      dir='ltr'
                                      value={item.outputTime}
                                      onChange={(e) => {
                                        item.outputTime = e.target.value;
                                        setDataFech([...dataFech]);
                                      }}
                                      disabled
                                    />
                                  </td>
                                </tr>

                                <tr>
                                  <td>تاریخ پایان کار</td>
                                  <td>
                                    <InputDate
                                      placeholder='00:00'
                                      name='endWork'
                                      handelValue={handleValue}
                                      defaultValue={item?.endWork?.slice(0, 10)}
                                    />
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <span>ساعت خروج کارفرما: </span>
                                  </td>
                                  <td>
                                    <InputMask
                                      mask='99:99'
                                      maskChar={'0'}
                                      placeholder='--:--'
                                      label='00:00'
                                      dir='ltr'
                                      value={
                                        item.realOutputTime !== null
                                          ? item.realOutputTime
                                          : null
                                      }
                                      onChange={(e) => {
                                        item.realOutputTime = e.target.value;
                                        setDataFech([...dataFech]);
                                      }}
                                    />
                                  </td>
                                </tr>
                              </td>
                              <td>
                                <tr>
                                  <td>
                                    <span>مبلغ قرارداد : </span>
                                  </td>
                                  <td>
                                    <NumberFormat
                                      dir='ltr'
                                      value={item.payableAmount}
                                      thousandSeparator={','}
                                      onChange={(e) => {
                                        item.payableAmount = e.target.value;
                                        setCalculatedPrices((prev) => ({
                                          ...prev,
                                          [item.id]: e.target.value,
                                        }));
                                        setDataFech([...dataFech]);
                                      }}
                                      disabled
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span>مبلغ ساعت کارفرما : </span>
                                  </td>
                                  <td>
                                    <NumberFormat
                                      dir='ltr'
                                      value={
                                        item.payableAmount !== undefined
                                          ? item.payableAmount
                                          : 0
                                      }
                                      thousandSeparator={','}
                                      onChange={(e) => {
                                        item.payableAmount = e.target.value;
                                        setCalculatedPrices((prev) => ({
                                          ...prev,
                                          [item.id]: e.target.value,
                                        }));
                                        setDataFech([...dataFech]);
                                      }}
                                      disabled
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>توضیحات</td>
                                  <td style={{ wordBreak: 'break-word' }}>
                                    {item?.description
                                      ? item?.description
                                      : '-'}
                                  </td>
                                </tr>
                              </td>
                              <td style={{ textAlign: 'center' }}>
                                <span style={{ wordBreak: 'break-word' }}>
                                  {item?.description ? item?.description : '-'}
                                </span>
                                <Divider />
                                {item?.isAbsent ? (
                                  <span>
                                    غیبت دارد
                                    <i
                                      className='mdi mdi-close'
                                      style={{
                                        color: 'red',
                                        fontSize: '1rem',
                                      }}
                                    ></i>
                                  </span>
                                ) : (
                                  <span>
                                    غیبت ندارد
                                    <i
                                      className='mdi mdi-check'
                                      style={{
                                        color: 'green',
                                        fontSize: '1rem',
                                      }}
                                    ></i>
                                  </span>
                                )}
                              </td>
                              <td style={{ textAlign: 'center' }}>
                                <span>
                                  {item?.supportDescriptions?.length > 0 ? (
                                    <Button
                                      disabled={loadingFrom}
                                      style={{
                                        backgroundColor: 'rgb(255, 157, 74)',
                                      }}
                                      onClick={() => handleDescription(item.id)}
                                    >
                                      نمایش
                                    </Button>
                                  ) : (
                                    '-'
                                  )}
                                </span>
                                <Divider />
                                <Button
                                  disabled={loadingFrom}
                                  onClick={() => {
                                    setIsReadOnly(false);
                                    setIdForModal(item.id);
                                    setDescriptionModal(true);
                                  }}
                                >
                                  افزودن
                                </Button>
                              </td>
                              <td className='text-center'>
                                {item?.typeTitle ? item?.typeTitle : '-'}
                              </td>
                              <td className='text-center'>
                                <Button
                                  onClick={() => {
                                    setRecord(item);
                                    setCancelModal(true);
                                  }}
                                  disabled={
                                    item?.type !== 6 && item?.type !== 7
                                  }
                                >
                                  <i className='mdi mdi-eye'></i>
                                </Button>
                              </td>
                              <td>
                                <tr class='d-flex justify-content-center'>
                                  <Button
                                    disabled={loadingFrom}
                                    onClick={async () => {
                                      await settimekarline(item);
                                      await datafeching(
                                        startpage,
                                        pageSize,
                                        serch,
                                        item
                                      );
                                    }}
                                  >
                                    محاسبه
                                  </Button>
                                </tr>
                              </td>

                              {/* <td>
                                {arryactions ? (
                                  arryactions.includes('Delete') ? (
                                    <Button
                                      variant={'danger'}
                                      onClick={() => {
                                        setShowMudule(true);
                                        setIdForModal(item.id);
                                      }}
                                    >
                                      <i className='mdi icon-sm mdi-delete'></i>
                                    </Button>
                                  ) : null
                                ) : accessPage.includes('Delete') ? (
                                  <i className='mdi icon-sm mdi-delete'></i>
                                ) : null}
                              </td>

                              <td>
                                <Button
                                  disabled={loadingFrom}
                                  variant={'danger'}
                                  onClick={() => {
                                    handlePenalty(item.id);
                                    setIdForModal(item.id);
                                  }}
                                >
                                  جریمه
                                </Button>
                              </td> */}
                            </tr>
                            <ConfirmModal
                              shouldShow={shouldShow}
                              setShouldShowShow={setShouldShow}
                              onOkFn={() => handleSubmit(itemData)}
                              modalTitle='ثبت تغییرات ورود و خروج نیرو'
                              modalQuestion={
                                'آیا شما مایل به ثبت اطلاعات هستید؟'
                              }
                            />
                          </>
                        );
                      })}

                      <ModalDelete
                        hasDescription
                        id={idForModal}
                        showitem={showMudule}
                        handleCloseMoudal={handleClose}
                        handeldeleteModal={handeldelete}
                        urldata={'/WorkerOrderSchedule'}
                      />

                      <Modal
                        show={penaltyModal}
                        onHide={() => {
                          setPenaltyModal(false);
                          setIdForModal(null);
                        }}
                      >
                        <Modal.Header>
                          <Modal.Title>لغو کار با جریمه</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Form
                            form={penaltyForm}
                            name='penaltyForm'
                            autoComplete='off'
                            initialValues={''}
                          >
                            <Row gutter={20}>
                              <Col span={12}>
                                <Form.Item name='workActionReasonId'>
                                  <InputControl
                                    name='workActionReasonId'
                                    label='دلیل لغو کار'
                                    url='/workActionReason/getCancelReasonDropDown'
                                    handelValue={(_, value) =>
                                      handleChange('workActionReasonId', value)
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item name='workCancelPolicyId'>
                                  <InputControl
                                    name='workCancelPolicyId'
                                    label='عنوان لغو کار'
                                    url='/workCancelPolicy/getDropDown'
                                    handelValue={(_, value) =>
                                      handleChange('workCancelPolicyId', value)
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={24} style={{ marginBottom: '2rem' }}>
                                <Alert
                                  message={
                                    'مبلغ جریمه محاسبه شده برای این حالت'
                                  }
                                  description={
                                    penaltyLoading ? (
                                      <Skeleton.Input />
                                    ) : penaltyBox?.penaltyAmount !== null &&
                                      penaltyBox?.penaltyAmount !==
                                        undefined ? (
                                      <Space direction='vertical'>
                                        <span>
                                          {penaltyBox?.penaltyAmount?.toLocaleString()}{' '}
                                          ریال
                                        </span>
                                        <span>
                                          <small>
                                            تعداد لغو کار باقی مانده تا اعمال
                                            حداکثر جریمه (بلاک نیرو):
                                          </small>{' '}
                                          {penaltyBox?.remainingCountToBlock ??
                                            '-'}
                                        </span>
                                      </Space>
                                    ) : (
                                      'برای مشاهده ابتدا عنوان لغو کار مد نظر را انتخاب کنید.'
                                    )
                                  }
                                  type='info'
                                  showIcon
                                />
                              </Col>
                              <Col span={24}>
                                <Form.Item name='description'>
                                  <div className='form-group'>
                                    <label htmlFor='description'>توضیحات</label>
                                    <textarea
                                      rows='6'
                                      id='description'
                                      className='form-control'
                                      onChange={(e) =>
                                        handleChange(
                                          'description',
                                          e.target.value
                                        )
                                      }
                                    ></textarea>
                                  </div>
                                </Form.Item>
                              </Col>
                            </Row>
                          </Form>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            key='submit'
                            variant={'danger'}
                            onClick={submitPenalty}
                          >
                            {submitLoading ? (
                              <i className='fa fa-spinner fa-pulse fa-fw'></i>
                            ) : (
                              'حذف نیرو'
                            )}
                          </Button>
                          <Button
                            key='back'
                            variant='secondary'
                            onClick={() => setPenaltyModal(false)}
                          >
                            بستن
                          </Button>
                        </Modal.Footer>
                      </Modal>

                      <Modal
                        show={descriptionModal}
                        onHide={() => {
                          setDescriptionModal(false);
                          setIdForModal(null);
                        }}
                      >
                        <Modal.Header>
                          <Modal.Title>توضیحات کارشناس</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          {isReadOnly ? (
                            <>
                              {history?.map((item) => (
                                <>
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: item,
                                    }}
                                  />
                                  <Divider />
                                </>
                              ))}
                            </>
                          ) : (
                            <div className='form-group'>
                              <label htmlFor='supportDescription'>
                                توضیحات
                              </label>
                              <textarea
                                rows='6'
                                id='supportDescription'
                                className='form-control'
                                onChange={(e) =>
                                  setSupportDescription(e.target.value)
                                }
                              ></textarea>
                            </div>
                          )}
                        </Modal.Body>
                        <Modal.Footer>
                          {!isReadOnly && (
                            <Button
                              key='submit'
                              variant={'success'}
                              onClick={submitDescription}
                            >
                              {submitDescriptionLoading ? (
                                <i className='fa fa-spinner fa-pulse fa-fw'></i>
                              ) : (
                                'ثبت'
                              )}
                            </Button>
                          )}
                          <Button
                            key='back'
                            variant='secondary'
                            onClick={() => setDescriptionModal(false)}
                          >
                            بستن
                          </Button>
                        </Modal.Footer>
                      </Modal>

                      <Modal
                        show={cancelModal}
                        onHide={() => {
                          setCancelModal(false);
                          setRecord({});
                        }}
                      >
                        <Modal.Header>
                          <Modal.Title>اطلاعات لغو کار / سفارش</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Descriptions bordered column={1} size={'small'}>
                            <Descriptions.Item label='وضعیت'>
                              {record?.typeTitle ?? 'اطلاعات وارد نشده'}
                            </Descriptions.Item>
                            <Descriptions.Item label='نام لغو کننده'>
                              {record?.cancelerName ?? 'اطلاعات وارد نشده'}
                            </Descriptions.Item>
                            <Descriptions.Item label='توضیحات لغو'>
                              {record?.cancelDescription ?? 'اطلاعات وارد نشده'}
                            </Descriptions.Item>
                            <Descriptions.Item label='عنوان لغو کار'>
                              {record?.policyTitle ?? 'اطلاعات وارد نشده'}
                            </Descriptions.Item>
                            <Descriptions.Item label='دلیل لغو کار'>
                              {record?.workActionReasonTitle ??
                                'اطلاعات وارد نشده'}
                            </Descriptions.Item>
                            <Descriptions.Item label='مبلغ جریمه (ریال)'>
                              {record?.penaltyAmount !== null
                                ? parseInt(
                                    record?.penaltyAmount
                                  )?.toLocaleString()
                                : 'اطلاعات وارد نشده'}
                            </Descriptions.Item>
                          </Descriptions>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            key='back'
                            variant='secondary'
                            onClick={() => setCancelModal(false)}
                          >
                            بستن
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </tbody>
                  </Table>
                </div>
              </>
            ) : (
              ' چیزی یافت نشد :('
            )
          ) : (
            <Loader />
          )}
        </>
      ) : (
        <Loader />
      )}
    </>
  );
}
